const formatDuration = seconds => {
	const value = Math.round(Number(seconds) || 0);
	if (value <= 0) return "-";

	const hours = Math.floor(value / 3600);
	const minutes = Math.floor((value % 3600) / 60);
	const secs = value % 60;

	if (hours > 0) {
		return `${hours}h ${minutes}min`;
	}
	if (minutes > 0) {
		return `${minutes}min ${secs}s`;
	}
	return `${secs}s`;
};

export default formatDuration;
